import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import usePageSeo from "./hooks/usePageSeo";
import { AppointmentProvider, useAppointment } from "./context/AppointmentContext";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import Conditions from "./components/Conditions";
import Testimonials from "./components/Testimonials";
import DoctorSection from "./components/DoctorSection";
import Locations from "./components/Locations";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import ForAttorneys from "./components/ForAttorneys";
import ForChiropractors from "./components/ForChiropractors";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import FAQ from "./components/FAQ";
import PrivacyPolicy from "./components/PrivacyPolicy";
import MeetTheDoctor from "./components/MeetTheDoctor";
import Contact from "./components/Contact";
import NotFound from "./components/NotFound";
import AppointmentModal from "./components/AppointmentModal";

const Home = () => {
  usePageSeo({
    title: "Regenerative Medicine & PRP Therapy Atlanta | ATL Regen",
    description: "ATL Regen provides regenerative medicine, PRP therapy, stem cell treatments, and pain management in Atlanta, GA. Schedule your consultation today.",
    canonical: "https://www.atlregen.com/",
    ogTitle: "Regenerative Medicine & PRP Therapy Atlanta | ATL Regen",
  });
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <WhyChooseUs />
        <Conditions />
        <Testimonials />
        <DoctorSection />
        <Locations />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

const AppContent = () => {
  const { isAppointmentModalOpen, closeAppointmentModal } = useAppointment();

  useEffect(() => {
    const swallowRecaptchaTimeout = (event) => {
      const message = String(event?.message || event?.reason?.message || "");
      const filename = String(event?.filename || "");
      const isRecaptchaTimeout = message.includes("reCAPTCHA Timeout")
        || message.includes("reCAPTCHA timeout");
      const fromRecaptchaScript = filename.includes("gstatic.com/recaptcha")
        || filename.includes("recaptcha__");

      if (isRecaptchaTimeout && fromRecaptchaScript) {
        event.preventDefault?.();
      }
    };

    window.addEventListener("error", swallowRecaptchaTimeout);
    window.addEventListener("unhandledrejection", swallowRecaptchaTimeout);
    return () => {
      window.removeEventListener("error", swallowRecaptchaTimeout);
      window.removeEventListener("unhandledrejection", swallowRecaptchaTimeout);
    };
  }, []);
  
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/for-attorneys" element={<ForAttorneys />} />
        <Route path="/for-chiropractors" element={<ForChiropractors />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/meet-the-doctor" element={<MeetTheDoctor />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <AppointmentModal isOpen={isAppointmentModalOpen} onClose={closeAppointmentModal} />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppointmentProvider>
        <AppContent />
      </AppointmentProvider>
    </BrowserRouter>
  );
}

export default App;
